export default __webpack_public_path__ + "static/media/after-school-club.b5b46526.svg";